import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
    token: localStorage.getItem('token') || null
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
    },
    LOGOUT(state) {
      state.token = null
      state.user = null
      localStorage.removeItem('token')
    }
  },
  actions: {
    login({ commit }, credentials) {
      // 实际项目中这里会发送API请求
      // 这里使用模拟数据
      return new Promise((resolve) => {
        setTimeout(() => {
          // 模拟成功登录
          const token = 'mock-token-' + Date.now()
          const user = {
            username: credentials.username,
            name: '管理员',
            role: 'admin'
          }
          commit('SET_TOKEN', token)
          commit('SET_USER', user)
          resolve(user)
        }, 1000)
      })
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  modules: {
  }
}) 